import { getProductSearch, getCollectProduct } from 'model/product';

export default store => ({
	path: 'search',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./component').default;
					cb(null, component);
				},
				'Search',
			),
		onEnter: ({
			location: {
				query: { keyword },
			},
		}) => {
			store.dispatch(getProductSearch(keyword, undefined, 1, 'price', 'desc', true));
			const {
				auth: { accessToken },
			} = store.getState();
			if (accessToken !== '') {
				store.dispatch(getCollectProduct());
			}
		},
		onChange: (
			_,
			{
				location: {
					query: { keyword },
				},
			},
		) => {
			store.dispatch(getProductSearch(keyword, undefined, 1, 'price', 'desc', true));
		},
	},
});
